export default function defaultExpirationDate() {
  const defaultDate = new Date();
  const currentYear = defaultDate.getFullYear();
  defaultDate.setFullYear(currentYear + 1);
  return defaultDate;
}
